import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'wraParentheses'
})
export class WraParenthesesPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(value: string): SafeHtml {
    const formattedValue = value.replace(/\(([^)]+)\)/g, '<br><span style="font-size:12px">($1)</span>');
    return this.sanitizer.bypassSecurityTrustHtml(formattedValue);
  }

}
